import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';

const Nav = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [today, setToday] = useState("");

    // Update date and day
    useEffect(() => {
        // 1. Set the date
        const options = { weekday: 'short', day: 'numeric', month: 'short' };
        setToday(new Date().toLocaleDateString('en-IN', options));  
    }, []); // Empty dependency array means this runs once on mount

    // Helper to set active class
    const isActive = (path) => location.pathname === path ? "active fw-bold text-primary border-bottom border-primary border-3" : "";

    const handleLogout = () => {
        if (window.confirm("Are you sure you want to logout?")) {
            localStorage.clear(); 
            sessionStorage.clear();
            navigate('/login'); 
            window.location.reload();
        }
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top py-2">
            <style>
                {`
                    .nav-link { transition: 0.2s; border-bottom: 3px solid transparent; }
                    .nav-link:hover { color: #0d6efd !important; }
                    .dropdown-item:active { background-color: #0d6efd; }
                    .navbar-brand { transition: 0.3s; }
                    .navbar-brand:hover { opacity: 0.8; }
                    
                    /* Custom Toggle Styles */
                    .form-check-input:checked { background-color: #198754; border-color: #198754; }
                    .status-dot { height: 8px; width: 8px; border-radius: 50%; display: inline-block; }
                    .dot-online { background-color: #198754; box-shadow: 0 0 5px #198754; }
                    .dot-offline { background-color: #dc3545; }
                `}
            </style>
            
            <div className="container">
                {/* BRAND NAME */}
                <Link className="navbar-brand fw-bold fs-3 text-primary" to="/dashboard" style={{ letterSpacing: '1px' }}>
                    SUFNA
                </Link>

                {/* MOBILE TOGGLE BUTTON */}
                <button 
                    className="navbar-toggler border-0 shadow-none" 
                    type="button" 
                    data-bs-toggle="collapse" 
                    data-bs-target="#navbarNav" 
                    aria-controls="navbarNav" 
                    aria-expanded="false" 
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* NAV LINKS */}
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0 mt-2 mt-lg-0">
                        <li className="nav-item">
                            <Link className={`nav-link px-3 ${isActive('/dashboard')}`} to="/dashboard">Home</Link>
                        </li>
                        {/* CRYSTAL DASHBOARD ADDED HERE */}
                        <li className="nav-item">
                            <Link className={`nav-link px-3 ${isActive('/crystaldashboard')}`} to="/crystaldashboard">Crystal Dashboard</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link px-3 ${isActive('/articles')}`} to="/articles">Articles</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link px-3 ${isActive('/customers')}`} to="/customers">Customers</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link px-3 ${isActive('/orders')}`} to="/orders">Orders</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link px-3 ${isActive('/reports')}`} to="/reports">Reports</Link>
                        </li>
                        <li className="nav-item">
                            <Link className={`nav-link px-3 ${isActive('/manage-website')}`} to="/manage-website">Website Data</Link>
                        </li>

                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle px-3 text-secondary" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Quick Actions
                            </a>
                            <ul className="dropdown-menu shadow border-0 mt-2">
                                <li><Link className="dropdown-item py-2" to="/crystal-dashboard">💎 Crystal Dashboard</Link></li>
                                <li><Link className="dropdown-item py-2" to="/addorder">➕ Add New Order</Link></li>
                                <li><Link className="dropdown-item py-2" to="/add-customer">👤 Add New Customer</Link></li>
                                <li><Link className="dropdown-item py-2" to="/addarticle">🎨 Create Article</Link></li>
                                <li><Link className="dropdown-item py-2" to="/inventory">📦 Manage Stock</Link></li>
                                <li><hr className="dropdown-divider" /></li>
                                <li><Link className="dropdown-item py-2" to="/expense-manager">💰 Batch Shipping Update</Link></li>
                                {/* <li><Link className="dropdown-item py-2" to="/reports">📊 Analytics</Link></li> */}
                            </ul>
                        </li>
                    </ul>

                    {/* RIGHT SIDE: SERVER SWITCH, DATE, PROFILE & LOGOUT */}
                    <div className="d-flex align-items-center gap-2 mt-3 mt-lg-0">

                        {/* DATE DISPLAY */}
                        <div className="px-3 py-1 bg-light rounded-pill border d-flex align-items-center me-1">
                            <small className="fw-bold text-secondary text-uppercase" style={{ fontSize: '0.75rem' }}>
                                📅 {today}
                            </small>
                        </div>

                        {/* PROFILE ICON */}
                        <div 
                            className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                            style={{ width: '35px', height: '35px', cursor: 'pointer', fontSize: '0.9rem', fontWeight: 'bold' }}
                            title="Admin Profile"
                        >
                            S
                        </div>

                        {/* LOGOUT BUTTON */}
                        <button 
                            type="button"
                            onClick={handleLogout}
                            className="btn btn-link text-danger text-decoration-none fw-bold ms-2 p-0 shadow-none"
                            style={{ fontSize: '0.85rem' }}
                        >
                            Logout 🚪
                        </button>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Nav;
